import { render, staticRenderFns } from "./BasicsSupplierInformation.vue?vue&type=template&id=d0a22c52&scoped=true"
import script from "./BasicsSupplierInformation.vue?vue&type=script&lang=js"
export * from "./BasicsSupplierInformation.vue?vue&type=script&lang=js"
import style0 from "./BasicsSupplierInformation.vue?vue&type=style&index=0&id=d0a22c52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a22c52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0a22c52')) {
      api.createRecord('d0a22c52', component.options)
    } else {
      api.reload('d0a22c52', component.options)
    }
    module.hot.accept("./BasicsSupplierInformation.vue?vue&type=template&id=d0a22c52&scoped=true", function () {
      api.rerender('d0a22c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsSupplierInformation/BasicsSupplierInformation.vue"
export default component.exports